import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [countryCode, setCountryCode] = useState("");

  useEffect(() => {
    // Fetch the user's country based on their IP
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        // ipapi returns the country code in ISO Alpha-2 format, which react-phone-input-2 expects
        const countryCode = response.data.country_code.toLowerCase();
        setCountryCode(countryCode);
      })
      .catch((error) => {
        console.error("Error fetching IP information:", error);
        // Optionally set a default or handle the error
      });
  }, []);

  const formValidationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "Minimum 3 characters")
      .matches(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, "Should be in A-Z, a-z letters")
      .required("Please enter your name"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please your email address"),
    phone: Yup.string().required("Please enter phone number"),
    company: Yup.string()
      .min(3, "Company name must be at least 3 characters")
      .required("Please enter your Company name"),
    message: Yup.string()
      .min(3, "Your requirement must be at least 3 characters")
      .required("Please enter your requirement"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
      pageLink: window.location.href,
    },
    validationSchema: formValidationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      if (window.grecaptcha) {
        window.grecaptcha.ready(async () => {
          const token = await window.grecaptcha.execute(
            "6LdRfrYpAAAAAM6i4yl1LJWvbrvxcnIhzqn1XWmB",
            { action: "submit" }
          );
          // Now you have a token, submit it to your backend along with form values
          const response = await axios.post(
            "https://capdigi.tech/2024/capdigisoft/v1/capbackend/submitForm.php",
            {
              mode: "addCenterModuleData_new",
              ...values,
              "g-recaptcha-response": token,
            }
          );

          if (response.status === 200) {
            // Handle successful submission
            navigate("/thankyou");
          } else {
            // Handle errors or unsuccessful submission
            console.error("Error submitting form data");
          }
          setIsSubmitting(false);
        });
      }
    },
  });

  return (
    <section className="section" id="contact">
      <div className="ct-wrapper shadow-md rounded-lg overflow-hidden">
        <div className="card-body">
          <div className="p-2">
            <form onSubmit={formik.handleSubmit}>
              {/* Name field */}
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Full Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  placeholder="Full Name"
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-danger">{formik.errors.name}</div>
                ) : null}
              </div>

              {/* Email field */}
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  placeholder="Email"
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger">{formik.errors.email}</div>
                ) : null}
              </div>

              {/* Phone field */}
              <div className="mb-3">
                <label htmlFor="phone" className="form-label">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <PhoneInput
                  // country={'us'}
                  placeholder="Phone"
                  // value={formik.values.phone}
                  onChange={(phone) => formik.setFieldValue("phone", phone)}
                  country={countryCode}
                  value={formik.values.phone}
                  //onChange={setPhone}
                  containerStyle={{ marginTop: "0.5rem" }}
                  inputStyle={{
                    width: "100%",
                    height: "38px",
                  }}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <div className="text-danger">{formik.errors.phone}</div>
                ) : null}
              </div>

              {/* Company field */}
              <div className="mb-3">
                <label htmlFor="company" className="form-label">
                  Company Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  name="company"
                  placeholder="Company Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company}
                />
                {formik.touched.company && formik.errors.company ? (
                  <div className="text-danger">{formik.errors.company}</div>
                ) : null}
              </div>

              {/* Message field */}
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Your Requirement <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="Your Requirement"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.message}
                ></textarea>
                {formik.touched.message && formik.errors.message ? (
                  <div className="text-danger">{formik.errors.message}</div>
                ) : null}
              </div>

              <button
                type="submit"
                className="btn cust-btn-primary secondary-main mt-3"
                disabled={isSubmitting}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
